export default "__VITE_ASSET__wEMB0dD2__"